import { useContext } from "react";
import { RegisterFinepCard } from "../../../Components/RegisterFinep/RegisterFinepCard";
import CardHeader from "../../../antd/components/CardHeader";
import { useParams } from "react-router-dom";
import { RegistrationDocumentsFinepContext } from "../../../Contexts/RegistrationDocumentsFinepContext";
import { CompanyFinepContext } from "../../../Contexts/CompanyFinepContext";
import { TechnologicalFeaturesFinepContext } from "../../../Contexts/TechnologicalFeaturesFinepContext";
import './styles.css';

const TechnologicalFeatures = require("../../../Assets/icons/TechnologicalFeatures.png");
const RegistrationDocuments = require("../../../Assets/icons/RegistrationDocuments.png");
const IndividualAndLegalEntity = require("../../../Assets/icons/IndividualAndLegalEntity.png");

const RegistrationFinep = () => {
    const { id, registerId } = useParams();
    const { validateValue: registrationValidateValue, loading: registrationLoading } = useContext(RegistrationDocumentsFinepContext);
    const { validateValue: companyValidateValue, loading: companyLoading } = useContext(CompanyFinepContext);
    const { validateValue: technologicalFeaturesValidateValue, loading: technologicalFeaturesLoading } = useContext(TechnologicalFeaturesFinepContext);

    return (
        <div className="card ml-2 mr-2">
            <CardHeader
                pageName={"Cadastro Finep"}
                hasPageBefore={true}
                linkPageBefore={`/register/${id}`}
                pageBeforeName={"Cadastro"}
            />
            <div className="cards-container">
                <RegisterFinepCard
                    text="Documentos Cadastrais"
                    percentage={registrationLoading ? 0 : Math.floor(registrationValidateValue)}
                    imageSrc={RegistrationDocuments}
                    route={`/registrationDocumentsFinep/${registerId}/${id}`}
                />
                <RegisterFinepCard
                    text="Pessoa Física e Jurídica"
                    percentage={companyLoading ? 0 : Math.floor(companyValidateValue)}
                    imageSrc={IndividualAndLegalEntity}
                    route={`/personaCompanyFinep/${registerId}/${id}`}
                />
                <RegisterFinepCard
                    text="Características Tecnologicas"
                    percentage={technologicalFeaturesLoading ? 0 : Math.floor(technologicalFeaturesValidateValue)}
                    imageSrc={TechnologicalFeatures}
                    route={`/technologicalFeaturesFinep/${registerId}/${id}`}
                />
            </div>
        </div>

    );
};

export default RegistrationFinep;